import { EnumTagType } from "@/lib/enum/tags";
import Model from "@/lib/model/model";

export default class CandidateListForm extends Model {
  examId = 0;
  // userId = 0;
  companyId = 0;
  asCompany = 0;
  phone = "";
  showNameLike = "";
  showNameOrPhone = "";
  searchKeyLike = "";
  tagNameList: string[] = [];
  submitStatusList: number[] = [];
  auditStatusList: number[] = []; //0未审核1通过2待定3拒绝
  judgeStatusList: number[] = []; //分配状态
  createdTime: string[] = [];
  beginTime: string[] = []; // 开始面试时间筛选
  submitTime: string[] = []; // 面试完成时间筛选
  candidateIdList: number[] = [];
  searchUserIdList: number[] = [];
  markCallbackStatusList: number[] = []; // 0未开始1待触发2执行成功3执行失败254发起成功等待回调255无需触发
  afterBuy = 0;
  sortKey = "score_all";
  sortDict = "asc";
  page = 1;
  pageSize = 10;
  total = 0;
  async = 0;
  ignore406 = false;
  isHrMark = 0;
  isFsk = 0;
  exportTaskName = "";
  paramSearchList: any = []; //登记信息筛选
  candidateId = 0;
  examType = "";
  judgeOutId = ""; //多人评估用
  passwd = "";
  showName = "";
  subExamId = 0;
  positionId = 0; // 岗位id
  aiRecommendStatusList: number[] = []; // AI推荐状态筛选
  outLinkStatusList: number[] = []; // 外链关系状态筛选
  examVersionId = 0; // 面试版本Id
  connectCodeList: string[] = []; // 候选人链接码列表
}

export class CandidateTagList {
  candidateId = 0;
  tags: string[] = [];
}

export class CandidateTags {
  companyId = "0";
  isReplace = false;
  candidateList: CandidateTagList[] = [new CandidateTagList()];
  tagType = EnumTagType.EnumTagTypeDefault;
}
